<template>

    <v-card id="explorecard" class="drag_overlay borderless d-flex flex-column" color="FFD375" fluid flat style="height:100%; width: 100%">

        <v-toolbar style="overflow:hidden" :height="toolbarheight" color="#FFA500" flat dense class="pb-0">
            <v-toolbar-items v-if="clickmode === 'normal'">
                <v-btn class="mx-0" text @click="setnavbar" color="black"><v-icon>menu</v-icon></v-btn>
                <div class="pa-1 mx-5 black--text menubold" text tile>EXPLORE</div>
                <v-btn text @click="home"><v-icon>home</v-icon></v-btn>
                <v-btn text @click="addTag"><v-icon>add_circle</v-icon></v-btn>

                <v-btn icon @click="openFullScreen"><img src="assets/openfullscreen.png"></v-btn>
                <v-btn icon @click="closeFullScreen"><img src="assets/closefullscreen.png"></v-btn>
                <v-btn icon v-if="letterboxpossible" @click="tripleScreen"><img src="assets/triplescreen.png"></v-btn>
                <v-btn icon v-if="letterboxpossible" @click="singleScreen"><img src="assets/singlescreen.png"></v-btn>
                <v-btn icon @click="levelUp"><img src="assets/level-up.png"></v-btn>
                <div class="labelsmall">{{debugstring}}</div>
            </v-toolbar-items>
            <v-toolbar-items v-if="clickmode === 'addtag'">
                <div class="pa-1 mx-5 black--text menuhead" text tile>Click on the image to add an alert at that point</div>
                <v-btn icon @click="closeAddTag"><img src="assets/close.png" height="20" width="20"></v-btn>
            </v-toolbar-items>
            <v-toolbar-items v-if="clickmode === 'addingtag'">
            </v-toolbar-items>
        </v-toolbar>

        <v-card :height="viewheight" v-if="currentmediatype === 'pano'">
            <iframe id="iframe1" v-if="screenmode === 'single'" class="mediaframe" :height="viewheight" :src="panoframesource" v-on:load="onLoadPano"></iframe>
            <iframe id="iframe1" v-if="screenmode === 'triple'" class="mediaframe1" :height="viewheight" :src="panoframesource" v-on:load="onLoadPano"></iframe>
            <iframe id="iframe2" v-if="screenmode === 'triple'" class="mediaframe2" :height="viewheight" :src="panoframesource" v-on:load="onLoadPano"></iframe>
            <iframe id="iframe3" v-if="screenmode === 'triple'" class="mediaframe3" :height="viewheight" :src="panoframesource" v-on:load="onLoadPano"></iframe>
        </v-card>

        <v-card class="mediaframe drag_overlay">
            <panZoom class="borderless" id="panzoom" :options="{minZoom: 0.5, maxZoom: 3}" @init="onImageInit" @pan="onPan" @zoom="onZoom">
                <v-card flat class="borderless" color="#FFFFFF">
                    <a ref="overlay">
                        <v-img flat style="cursor: pointer" @click="imageClick" class="borderless" ref="imagex" id="vimage" v-if="currentmediatype === 'image'" :height="viewheight" v-on:load="onLoadImage" :src="imageframesource" contain />
                    </a>
                </v-card>
            </panZoom>
        </v-card>

        <v-card id="exploretoolcard" v-if="clickmode === 'normal'" style="position:absolute; top:50px; left:0px; width:131px; height:334px;" flat color="#FFA500">
            <v-card flat color="#FFA500">
                <div style="position:absolute; top:6px; left:7px; width:124px;" class="labelclock">{{clockstring}}</div>
                <div style="position:absolute; top:47px; left:7px; width:40px;" class="labelsmall">Media</div>
                <div style="position:absolute; top:43px; left:50px; width:80px;" class="labelbold mt-0">{{mediastring}}</div>
                <v-btn style="position:absolute; top:68px; left:5px; width:40px;" text :disabled="firstmedia" @click="prevMedia"><v-icon size="35" class="fliphoriz">play_arrow</v-icon></v-btn>
                <v-btn style="position:absolute; top:68px; left:60px; width:40px;" text :disabled="lastmedia" @click="nextMedia"><v-icon size="35" class="ma-0 pl-0">play_arrow</v-icon></v-btn>

                <div style="position:absolute; top:115px; left:7px; width:40px;" class="labelsmall">Survey alerts</div>
                <div style="position:absolute; top:120px; left:50px; width:80px;" class="labelbold mt-0">{{surveyalertstring}}</div>
                <v-btn style="position:absolute; top:150px; left:5px; width:40px;" text :disabled="firstsurveytag" @click="prevSurveyTag"><v-icon size="35" class="fliphoriz">play_arrow</v-icon></v-btn>
                <v-btn style="position:absolute; top:150px; left:60px; width:40px;" text :disabled="lastsurveytag" @click="nextSurveyTag"><v-icon size="35">play_arrow</v-icon></v-btn>

                <div style="position:absolute; top:193px; left:7px; width:40px;" class="labelsmall">Image alerts</div>
                <div style="position:absolute; top:199px; left:50px; width:80px;" class="labelbold mt-0">{{mediaalertstring}}</div>
                <v-btn style="position:absolute; top:227px; left:5px; width:40px;" text @click="prevImageTag" :disabled="firstmediatag"><v-icon size="35" class="fliphoriz">play_arrow</v-icon></v-btn>
                <v-btn style="position:absolute; top:227px; left:60px; width:40px;" text @click="nextImageTag" :disabled="lastmediatag"><v-icon size="35">play_arrow</v-icon></v-btn>

                <v-btn text style="position:absolute; top:262px; left:35px; width:40px;" @click="showMap"><v-icon>map</v-icon></v-btn>

                <v-btn :color="realtimecolor" style="position:absolute; top:297px; left:0px; width:131px;" @click="toggleRealtime"><v-icon>refresh</v-icon></v-btn>

            </v-card>
        </v-card>

        <v-card id="textbox" v-if="tagnote" :style=hstyle :width="210" :color="alertlevel">
            <v-card :color="alertlevel" :height="34">
                <label style="position:absolute; left:2px; top:5px"> {{ selectedtag.CreatorTag }} </label>
                <label style="position:absolute; left:45px; top:7px" class="labelsmall"> {{ selectedtag.HowOld }} </label>
                <v-btn v-if="trafficlight" icon text style="position:absolute; left:123px; top:0px" @click="rateImportance"><img src="assets/traffic-light.png" height="20" width="20"></v-btn>
                <v-btn text style="position:absolute; left:153px; top:2px" fab x-small @click="addNote"><v-icon>add_circle</v-icon></v-btn>
                <v-btn icon small style="position:absolute; left:183px; top:4px" @click="closeNote"><img src="assets/close.png" height="20" width="20"></v-btn>
            </v-card>
            <v-card v-if="setalert" :height="34" :color="alertlevel">
                <label style="position:absolute; left:3px; top:5px">Set alert level</label>
                <v-btn icon text style="position:absolute; left:102px; top:0px" @click="setAlertLevel(1)"><img src="assets/green-alert.png" height="20" width="20"></v-btn>
                <v-btn icon text style="position:absolute; left:137px; top:0px" @click="setAlertLevel(2)"><img src="assets/amber-alert.png" height="20" width="20"></v-btn>
                <v-btn icon text style="position:absolute; left:172px; top:0px" @click="setAlertLevel(3)"><img src="assets/red-alert.png" height="20" width="20"></v-btn>
            </v-card>
            <v-card v-if="addnotetext" :height="130" color="#FFD375">
                <v-textarea class="text-wrap" style="position:absolute; left:0px; top:5px; height:50px; width:210px" name="newnote" label="Click here to add note" v-model="newnote" :rules="noteRules"></v-textarea>
            </v-card>
            <v-card class="overflow-y-auto" :style=nstyle color="#FFD375">
                <v-card v-for="note in notes" :note="note">
                    <label> {{ note.CreatorTag }} </label>
                    <label style="color:#FF0000;" class="labelsmall"> {{ note.HowOld }} </label>
                    <label> {{ note.EText }} </label>
                </v-card>
            </v-card>
        </v-card>

    </v-card>

    </template>

    <script>

        //<v-card : class="'mt-auto'" width="100%" color="#FFA500">
        //                <div class="labelsmall mt-0">{{panzoomtrans}}</div>

        //<v-card id="exploretoolcard" class="mt_auto1" width="100%" color="#FFA500">

        import Vue from 'vue';
        import Button from '@/components/Button';
        import firebase from 'firebase';
        import { browsertype, tagcount, updatetag, getsystemmillis, monitorbandwidth, getsurveyage } from '@/functions.js';

        export default {
            components: { Button },
            mounted: function () {
                this.settoolbarheight();
                alert("windowHeight " + window.screen.height + " " + this.toolbarheight + " " + browsertype());
                if (this.timer == null) {
                    var tk = this;
                    this.timer = setInterval(function () {
                        //update clock
                        if (tk.currentmedia == null) {
                            tk.mediatime = null;
                        }
                        else {
                            var tm = tk.currentmedia.CreatedTime;
                            var date = new Date();
                            var ticks = ((date.getTime() * 10000) + 621355968000000000);
                            tk.mediatime = ticks - tm;
                        }
                    }, 1000);
                }
                window.onmessage = (event) => {
                    if (event != null) {
                        try {
                            var arr = event.data.split(':');
                            if (arr[0] === "krpanowindow")
                                this.$store.state.iframewindow = event.source.window;
                            if (arr[0] === "panoclick") {
                                alert("panoclick in Explorer");
                            }
                        }
                        catch (err) {
                        }
                    }
                };

                this.$nextTick(function () {
                    window.addEventListener('resize', this.getWindowWidth);
                    window.addEventListener('resize', this.getWindowHeight);
                    this.getWindowWidth();
                    this.getWindowHeight();
                });

                var thisthis = this;

                window.addEventListener('iframe_message', function (e) {
                    //var url = e.detail.url
                    var arr = e.detail.split(':');
                    if (arr[0] === "krpanowindow")
                        thisthis.$store.state.iframewindow = event.source.window;
                    if (arr[0] === "hotspotclick") {
                        if (thisthis.hotspotclickstring != e.detail) {
                            thisthis.hotspotclickstring = e.detail
                            var hid = arr[2];
                            var x = Number(arr[3]);
                            var y = Number(arr[4]);
                            //alert("hotspotclick " + hid + " " + x + " " + y);
                            thisthis.overlayButtonClicked(hid,x,y);
                        }
                    };
                    if (arr[0] === "panoclick") {
                        thisthis.tagnote = false;
                        thisthis.setalert = false;
                        thisthis.addnotetext = false;
                        if (thisthis.$store.state.clickmode === "addtag"){
                            //alert("panoclick in Explorer id=" + e.detail);
                            thisthis.panoclickstring = e.detail;
                            var yaw = Number(arr[2]);
                            var pitch = Number(arr[3]);
                            var xscreen = Number(arr[4]);
                            var yscreen = Number(arr[5]);
                            thisthis.$store.state.yaw = yaw;
                            thisthis.$store.state.pitch = pitch;
                            thisthis.$store.state.addtagbutton = true;
                            thisthis.$store.state.addtagvisible = !thisthis.$store.state.addtagvisible;
                            thisthis.$store.state.clickmode = "addingtag";
                            //thisthis.tagnote = true;
                        }
                    };
                    if (arr[0] === "mousedown") {
                        thisthis.mousescreen = arr[1];
                    };
                    if (arr[0] === "loadcomplete") {
                        //console.log("loadcomplete in Explorer " + e.detail);
                        var loadmillis = getsystemmillis() - thisthis.startdownload;
                        if (loadmillis < 10000000) {
                            var servedtag = "";
                            if (monitorbandwidth(thisthis.currentmedia.DownloadURL, thisthis.currentmedia.Size)) {
                                servedtag = "*";
                            }
                            //thisthis.debugstring = 'loadtime P ' + thisthis.$store.state.screenmode + " " + arr[1] + " " + loadmillis + " " + servedtag;

                            if (thisthis.$store.state.screenmode === "triple") {
                                alert("loadcomplete triple");
                            }
                            else {
                                //console.log("loadcomplete X in Explorer " + e.detail);
                                thisthis.loading = false;
                                var yaw = thisthis.$store.state.pagememory[thisthis.medianumber].yaw;
                                var pitch = thisthis.$store.state.pagememory[thisthis.medianumber].pitch;
                                var fov = thisthis.$store.state.pagememory[thisthis.medianumber].zoom;
                                var iframe1 = document.getElementById("iframe1");
                                iframe1.contentWindow.fromC('lookat:' + yaw + ':' + pitch + ":" + fov, '*');
                            }

                            thisthis.loadTags();
                            var g = 0;
                        }
                    };
                    if (arr[0] === "viewchanged") {
                        //console.log("viewchanged in Explorer " + e.detail + " mousecreen=" + thisthis.mousescreen);
                        if (thisthis.$store.state.screenmode === "triple") {
                            if ((arr[1] === "2") && ("2" === thisthis.mousescreen)) {
                                thisthis.yaw = Number(arr[2]);
                                thisthis.pitch = Number(arr[3]);
                                thisthis.fov = Number(arr[4]);
                                thisthis.rememberMediaView(thisthis.yaw,thisthis.pitch,thisthis.fov);
                                var iframe1 = document.getElementById("iframe1");
                                var iframe3 = document.getElementById("iframe3");
                                iframe1.contentWindow.fromC('lookat:' + (thisthis.yaw - thisthis.fov) + ':' + thisthis.pitch, '*');
                                iframe3.contentWindow.fromC('lookat:' + (thisthis.yaw + thisthis.fov) + ':' + thisthis.pitch, '*');
                                thisthis.repeatAction("set3Screens");
                            };
                            if ((arr[1] === "1") && ("1" === thisthis.mousescreen)) {
                                thisthis.yaw = Number(arr[2]) + 90;
                                thisthis.pitch = Number(arr[3]);
                                thisthis.rememberMediaView(thisthis.yaw, thisthis.pitch, thisthis.fov);
                                var iframe2 = document.getElementById("iframe2");
                                var iframe3 = document.getElementById("iframe3");
                                iframe2.contentWindow.fromC('lookat:' + (thisthis.yaw) + ':' + thisthis.pitch, '*');
                                iframe3.contentWindow.fromC('lookat:' + (thisthis.yaw + thisthis.fov) + ':' + thisthis.pitch, '*');
                                thisthis.repeatAction("set3Screens");
                            };
                            if ((arr[1] === "3") && ("3" === thisthis.mousescreen)) {
                                thisthis.yaw = Number(arr[2]) - 90;
                                thisthis.pitch = Number(arr[3]);
                                thisthis.rememberMediaView(thisthis.yaw, thisthis.pitch, thisthis.fov);
                                var iframe2 = document.getElementById("iframe2");
                                var iframe1 = document.getElementById("iframe1");
                                iframe2.contentWindow.fromC('lookat:' + (thisthis.yaw) + ':' + thisthis.pitch, '*');
                                iframe1.contentWindow.fromC('lookat:' + (thisthis.yaw - thisthis.fov) + ':' + thisthis.pitch, '*');
                                thisthis.repeatAction("set3Screens");
                            };
                            if (thisthis.mousescreen === "")
                                thisthis.repeatAction("set3Screens");
                        }
                        else {
                            if ((arr[1] === "1") && ("1" === thisthis.mousescreen)) {
                                thisthis.yaw = Number(arr[2]);
                                thisthis.pitch = Number(arr[3]);
                                thisthis.fov = Number(arr[4]);
                                thisthis.rememberMediaView(thisthis.yaw, thisthis.pitch, thisthis.fov);
                            };
                        }
                    }
                }, false);

            },
            destroyed: function () {
                clearInterval(this.timer);
            },
            data() {
                return {
                    touchx: 0,
                    touchy: 0,
                    touchstart: 0,
                    toolbarheight: "50px",
                    panoclickstring: "",
                    hotspotclickstring: "",
                    setting: false,
                    loading: false,
                    mediatime: null,
                    timer:null,
                    showlastmedia: false,
                    realtimecolor:"#FFA500",
                    trafficlight: false,
                    debugstring: "",
                    startdownload: 0,
                    panzoomtrans: "",
                    setalert: false,
                    alertlevel: "#00FF00",
                    newnote:"",
                    note: "",
                    notes: null,
                    hstyle: "position: absolute; left:200px; top: 200px",
                    nstyle: "",
                    imagetransform: {scale:1, x:0, y:0},
                    tagnote: false,
                    fullscreen: false,
                    earliertags: false,
                    latertags: false,
                    selectedtagid: "",
                    selectedtag: null,
                    currentsurveymodified:0,
                    medianumber: 0,
                    mediatagcount: 0,
                    surveymediatags: [],
                    currentmedia: null,
                    currentmediatype: "",
                    panzoominst: null,
                    originaltransform: null,
                    originalboundingbox: { x: 0, y: 0, w: 1, h: 1 },
                    imageheight: 0,
                    imagewidth: 0,
                    viewwidth: 0,
                    viewheight: 0,
                    windowWidth: 0,
                    windowHeight: 0,
                    windowAspectRatio: 0,
                    defaultFOV: 90,
                    mousescreen: "1",
                    actiontorepeat: "",
                    repeatvar: null,
                    hmap: 0,
                    vmap: 0,
                    pitch: 0,
                    yaw: 0,
                    fov: 90,
                    addnotetext: false,
                    noteRules: [],
                    //panoframesource: 'krpano/empty/index.html',
                    panoframesource: 'krpano/missionroom/empty/index.html',
                    imageframesource: "",
                    panoimage: "https://firebasestorage.googleapis.com/v0/b/missionshare-2f93c.appspot.com/o/sphericalimage.jpg?alt=media&token=e268a03d-26de-4cdd-aeeb-512202ea9ab9"
                }
            },
            methods: {
                settoolbarheight() {
                    if (browsertype() === "Safari") this.toolbarheight = "25px";
                    this.toolbarheight = "50px";
                },
                toggleRealtime() {
                    if (this.realtimecolor === "#FFA500") {
                        this.showlastmedia = true;
                        this.medianumber = this.$store.state.mediacount;
                        this.realtimecolor = "#00BB00";
                    }
                    else {
                        this.realtimecolor = "#FFA500";
                        this.showlastmedia = false;
                    }
                },
                setMarkers() {
                    this.$store.state.mapmarkers = [];
                    this.$store.state.mapmarkerclicked = -1;
                    for (var key in this.$store.state.exploresurvey.media) {
                        var lat = this.$store.state.exploresurvey.media[key].Latitude;
                        var lng = this.$store.state.exploresurvey.media[key].Longitude;
                        this.$store.state.mapmarkers.push(L.latLng(lat, lng));
                        if (this.$store.state.mapmarkers.length == 1) {
                            this.$store.state.mapcentre = L.latLng(lat, lng);
                        }
                    }
                },
                rateImportance() {
                    this.setalert = true;
                },
                updateTag() {
                    updatetag(this.selectedtag, this.selectedtagid, false);
                },
                setAlertLevel(lev) {
                    if (lev == 1) {
                        this.alertlevel = "#00FF00";
                        this.selectedtag.Rating = '*green';
                    }
                    if (lev == 2) {
                        this.alertlevel = "#FFA500";
                        this.selectedtag.Rating = '*amber';
                    }
                    if (lev == 3) {
                        this.alertlevel = "#FF0000";
                        this.selectedtag.Rating = '*red';
                    }
                    this.$store.state.alertlevel = this.alertlevel;
                    this.setalert = false;
                    this.updateTag();
                    this.createOverlays();
                },
                addNote() {
                    if (this.addnotetext) {
                        this.confirmNote();
                    }
                    else {
                        this.addnotetext = true;
                    }
                },
                confirmNote() {
                    if (this.newnote.length > 0) {
                        delete this.selectedtag.HowOld;
                        for (var key in this.selectedtag.Notes) {
                            delete this.selectedtag.Notes[key].HowOld;
                            delete this.selectedtag.Notes[key].EText;
                        };
                        var date = new Date();
                        var time = ((date.getTime() * 10000) + 621355968000000000);
                        var id = "" + time;
                        if (this.selectedtag.Notes == null) {
                            this.selectedtag.Notes = new Object();
                        };
                        this.selectedtag.Notes[id] = { CreatorID: this.$store.state.currentuser.ID, CreatorTag: this.$store.state.currentuser.Tag, Text: escape(this.newnote), Time: time };

                        var count = 1;
                        for (var key in this.selectedtag.Notes) {
                            count++;
                            var tm = this.selectedtag.Notes[key].Time;
                            this.selectedtag.Notes[key].HowOld = this.getage(tm);
                            this.selectedtag.Notes[key].EText = unescape(this.selectedtag.Notes[key].Text);
                        };
                        this.selectedtag.Total = count;
                        this.updateTag();
                    }
                    this.addnotetext = false;
                    this.newnote = "";
                },
                forgetNote() {
                    this.addnotetext = false;
                    this.newnote = "";
                },
                closeNote() {
                    this.tagnote = false;
                    this.addnotetext = false;
                    this.newnote = "";
                },
                rememberMediaView(yaw, pitch, zoom) {
                    if ((this.loading) || (this.medianumber==0) || (this.setting))
                        return;
                    console.log("rememberMediaView " + this.medianumber + " " + yaw + " " + pitch + " " + zoom);
                    if (this.$store.state.pagememory[this.medianumber] == null) {
                        this.$store.state.pagememory[this.medianumber] = {yaw:0, pitch:0, zoom:1};
                    }
                    this.$store.state.pagememory[this.medianumber].yaw = yaw;
                    this.$store.state.pagememory[this.medianumber].pitch = pitch;
                    this.$store.state.pagememory[this.medianumber].zoom = zoom;             
                },
                onPan(event) {
                    this.imagetransform = event.getTransform();
                    this.yaw = this.imagetransform.x;
                    this.pitch = this.imagetransform.y;
                    this.fov = this.imagetransform.scale;
                    this.rememberMediaView(this.imagetransform.x, this.imagetransform.y, this.imagetransform.scale);
                    if (this.tagnote)
                        this.redrawNotesBox();
                },
                onZoom(event) {
                    this.imagetransform = event.getTransform();
                    this.yaw = this.imagetransform.x;
                    this.pitch = this.imagetransform.y;
                    this.fov = this.imagetransform.scale;
                    this.rememberMediaView(this.imagetransform.x, this.imagetransform.y, this.imagetransform.scale);
                    if (this.tagnote)
                        this.redrawNotesBox();
                },
                setnavbar() {
                    this.$store.state.navpage.setnavbar();
                },
                getoriginalimageboundingbox() {
                    var x = 0;
                    var y = 0;
                    var w = 0;
                    var h = 0;
                    // use aspect ratios to get width and height
                    var screen_aspect_ratio = this.viewwidth / this.viewheight;
                    var image_aspect_ratio = this.imagewidth / this.imageheight;
                    if (screen_aspect_ratio > image_aspect_ratio) {
                        //we have a portrait situation
                        //h = this.viewheight * this.$store.state.imagetransform.scale;  
                        h = this.viewheight;                    
                        w = h * image_aspect_ratio;
                        this.vmap = 1.0;
                        this.hmap = (w / this.viewwidth * 1.0);
                        x = 0;
                        //alert("PORT sar=" + screen_aspect_ratio + " iar=" + image_aspect_ratio + " hmap=" + this.hmap);
                    }
                    else {
                        //we have a landscape situation
                        //w = this.viewwidth * this.$store.state.imagetransform.scale;    
                        w = this.viewwidth; 
                        h = w / image_aspect_ratio;
                        this.hmap = 1.0;
                        this.vmap = (h / this.viewheight * 1.0);
                        x = 0;
                        //alert("LAND sar=" + screen_aspect_ratio + " iar=" + image_aspect_ratio + " vmap=" + this.vmap);
                    }
                    x = (this.viewwidth / 2) - (w / 2) + this.$store.state.imagetransform.x;            // + ImageView.TranslationX;
                    y = (this.viewheight / 2) - (h / 2) + this.$store.state.imagetransform.y;        // + ImageView.TranslationY;

                    this.originalboundingbox.x = Math.round(x);
                    this.originalboundingbox.y = Math.round(y);
                    this.originalboundingbox.h = Math.round(h);
                    this.originalboundingbox.w = Math.round(w);
                    //alert("BOX x=" + this.originalboundingbox.x + " w=" + this.originalboundingbox.w);
                    this.windowAspectRatio = screen_aspect_ratio;            
                },
                set1Screen(repeat) {
                    var iframe1 = document.getElementById("iframe1");
                    iframe1.contentWindow.fromC('lookat:' + this.yaw + ':' + this.pitch, '*');
                    if (repeat)
                        this.repeatAction("set1Screen");
                },
                set3Screens(repeat) {
                    var iframe1 = document.getElementById("iframe1");
                    iframe1.contentWindow.fromC("setfovlimits:60:90:" + this.fov);
                    iframe1.contentWindow.fromC('lookat:' + (this.yaw - this.fov) + ':' + this.pitch, '*');
                    var iframe2 = document.getElementById("iframe2");
                    iframe2.contentWindow.fromC("setfovlimits:60:90:" + this.fov);
                    iframe2.contentWindow.fromC('lookat:' + this.yaw + ':' + this.pitch, '*');
                    var iframe3 = document.getElementById("iframe3");
                    iframe3.contentWindow.fromC("setfovlimits:60:90:"+this.fov);
                    iframe3.contentWindow.fromC('lookat:' + (this.yaw + this.fov) + ':' + this.pitch, '*');
                    if (repeat)
                        this.repeatAction("set3Screens");
                },
                onLoadPano(event) {
                    this.defaultFOV = 90;
                    if (this.$store.state.screenmode === "triple") {
                        var iframe1 = document.getElementById("iframe1");
                        iframe1.contentWindow.fromC("setpanoid:1");
                        iframe1.contentWindow.fromC("loadpano:" + this.panoimage);
                        iframe1.contentWindow.fromC("setfovlimits:60:90:90");
                        var iframe2 = document.getElementById("iframe2");
                        iframe2.contentWindow.fromC("setpanoid:2");
                        iframe2.contentWindow.fromC("loadpano:" + this.panoimage);
                        iframe2.contentWindow.fromC("setfovlimits:60:90:90");
                        var iframe3 = document.getElementById("iframe3");
                        iframe3.contentWindow.fromC("setpanoid:3");
                        iframe3.contentWindow.fromC("loadpano:" + this.panoimage);
                        iframe3.contentWindow.fromC("setfovlimits:60:90:90");
                        this.set3Screens(true);
                    }
                    else {
                        try {
                            var iframe1 = document.getElementById("iframe1");
                            iframe1.contentWindow.fromC("setpanoid:1");
                            iframe1.contentWindow.fromC("loadpano:" + this.panoimage);
                            iframe1.contentWindow.fromC("setfovlimits:60:120:90");
                            this.set1Screen(true);
                        }
                        catch (e) {

                        }
                    }
                    this.filterTagsForMedia();
                    //alert('onLoadPano');
                    this.updateToolbars();
                },
                touchStart(event) {
                    this.touchx = event.touches[0].clientX;
                    this.touchy = event.touches[0].clientY;
                    this.touchstart = getsystemmillis();
                },
                touchEnd(event) { 
                    var ref = this.$refs.imagex;
                    var ix = ref.$el.offsetLeft;
                    var iy = ref.$el.offsetTop;
                    var elapsed = getsystemmillis() - this.touchstart;
                    if (elapsed < 500) {
                        alert((this.touchx - ix) + " " + (this.touchy - iy));
                    }
                },
                onLoadImage() {  
                    var ref = this.$refs.imagex;
                    var img = ref.image;
                    ref.$el.addEventListener("touchstart", this.touchStart, false);
                    ref.$el.addEventListener("touchend", this.touchEnd, false);
                    //var thisthis = this;
                    /*
                    ref.$el.addEventListener("touchstart", function (e) {
                        thisthis.touchx = e.touches[0].clientX;
                    });
                    ref.$el.addEventListener("touchend", function (e) {
                        alert(thisthis.touchx + " " + e.touches[0].clientX);
                    });
                    */
                    this.imageheight = img.naturalHeight;
                    this.imagewidth = img.naturalWidth;
                    this.getoriginalimageboundingbox();
                    //alert('loadedImage ' + this.imagewidth + "," + this.imageheight + "," + this.viewwidth + "," + this.viewheight);
                    this.$store.state.imageloaded = true;

                    var loadmillis = getsystemmillis() - this.startdownload;
                    var servedtag = "";
                    if (monitorbandwidth(this.currentmedia.DownloadURL, this.currentmedia.Size)) {
                        servedtag = "*";
                    }
                    //this.debugstring = 'loadtime I ' + loadmillis + " " + servedtag;
                    this.setZoomPan();
                    this.loading = false;
                    this.loadTags();
                    //alert('onLoadImage');
                    this.updateToolbars();
                },
                updateToolbars() {

                },
                updatePage() {
                    this.loadTags();
                },
                onImageInit: function (panzoomInstance, id) {
                    //console.log("onImageInit A ");
                    this.panzoominst = panzoomInstance;
                    var thisthis = this;
                    panzoomInstance.on('transform', function (e) {
                        var t = e.getTransform();
                        var vimgx = document.getElementById('vimage');
                        if (vimgx != null) {
                            var vueInstance = vimgx.__vue__;
                            vueInstance.$store.state.imagetransform = t;
                            thisthis.panzoomtrans = "" + t.scale + " " + t.x + " " + t.y;
                            //console.log("onImageInit B " + t.scale);
                            if (t.scale != thisthis.$store.state.pagememory[thisthis.medianumber].zoom) {
                                //thisthis.setZoomPan();
                            }
                        }
                    });
                },
                imageClick(event) {
                    this.tagnote = false;
                    this.setalert = false;
                    this.addnotetext = false;
                    if (this.clickmode === 'addtag') {
                        var pz = document.getElementById("panzoom").firstChild.firstChild;
                        var st = pz.style;
                        var tm = st.transform;
                        var l = tm.length;
                        var s= tm.substring(7, l - 1);
                        var arr = s.split(',');
                        var scale = Number(arr[3]);
                        var clientw = pz.clientWidth * scale;
                        var clienth = pz.clientHeight * scale;
                        var offsetx = Number(arr[4]);
                        var offsety = Number(arr[5]);
                        var x = event.clientX;
                        var y = event.clientY;
                        var xx = x - offsetx;
                        var yy = y - offsety - 48;
                        var image_aspect_ratio = this.imagewidth / this.imageheight;
                        var yaw, pitch;
                        if (this.vmap > this.hmap) {                    //portrait
                            var ww = clienth * image_aspect_ratio;
                            var offX = (clientw - ww) / 2;
                            pitch = yy / clienth;
                            yaw = (xx - offX) / ww;
                            alert("check explore imageClick portrait " + yaw + " " + pitch);
                        }
                        else {                                          //landscape
                            //alert("check explore imageClick in ");
                            var hh = clientw / image_aspect_ratio;
                            var offY = (clienth - hh) / 2;
                            pitch = (yy - offY) / hh;
                            yaw = xx / clientw;
                            alert("check explore imageClick landscape " + yaw + " " + pitch);
                            
                        }
                        //alert("yaw " + yaw + " pitch " + pitch);
                        if ((yaw < 0) || (yaw > 1)) return;
                        if ((pitch < 0) || (pitch > 1)) return;
                        this.$store.state.yaw = yaw;
                        this.$store.state.pitch = pitch;
                        this.$store.state.addtagbutton = true;
                        this.$store.state.addtagvisible = !this.$store.state.addtagvisible;
                        this.$store.state.clickmode = "addingtag";
                    }
                },
                openFullScreen() {
                    var elem = document.documentElement;
                    if (elem.requestFullscreen) {
                        elem.requestFullscreen();
                    } else if (elem.mozRequestFullScreen) { /* Firefox */
                        elem.mozRequestFullScreen();
                    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                        elem.webkitRequestFullscreen();
                    } else if (elem.msRequestFullscreen) { /* IE/Edge */
                        elem.msRequestFullscreen();
                    };
                    this.fullscreen = true;
                },
                closeFullScreen() {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) { /* Firefox */
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE/Edge */
                        document.msExitFullscreen();
                    }
                    this.fullscreen = false;
                },
                doAction() {
                    if (this.actiontorepeat === "singleScreen")
                        this.singleScreen(false);
                    if (this.actiontorepeat === "tripleScreen")
                        this.tripleScreen(false);
                    if (this.actiontorepeat === "set3Screens")
                        this.set3Screens(false);
                    if (this.actiontorepeat === "set1Screen")
                        this.set1Screen(false);
                    clearTimeout(this.repeatvar);
                },
                levelUp() {
                    this.pitch = 0;
                    if (this.currentmediatype === "image") {
                        this.rememberMediaView(this.yaw, 0, this.fov);
                        this.setZoomPan();
                    }
                    else {
                        if (this.$store.state.screenmode === "triple")
                            this.set3Screens(true);
                        else
                            this.set1Screen(true);
                    }
                },
                repeatAction(cmd) {
                    this.actiontorepeat = cmd;
                    this.repeatvar = setTimeout(this.doAction, 500);
                },
                tripleScreen(repeat) {
                    this.$store.state.screenmode = "triple";
                    this.set3Screens(true);
                    if (repeat)
                        this.repeatAction("tripleScreen");
                },
                singleScreen(repeat) {
                    this.$store.state.screenmode = "single";
                    var iframe1 = document.getElementById("iframe1");
                    iframe1.contentWindow.fromC('lookat:' + this.yaw + ':' + this.pitch, '*');
                    iframe1.contentWindow.fromC("setfovlimits:60:120:0");
                    if (repeat)
                        this.repeatAction("singleScreen");
                },
                prevMedia() {
                    this.medianumber--;
                },
                nextMedia() {
                    this.medianumber++;
                },
                prevSurveyTag() {
                    var count = 1;
                    var newkey = 1;
                    for (var key in this.$store.state.exploresurvey.media) {                      
                        if (key === this.currentmedia.ID) {
                            this.medianumber = newkey;
                            return;
                        }
                        if (tagcount(this.$store.state.exploresurvey.media[key].tags) > 0) {
                            newkey = count;
                        }
                        count++;
                    }
                },
                nextSurveyTag() {
                    var count = 1;
                    var found = false;
                    for (var key in this.$store.state.exploresurvey.media) {
                        if (tagcount(this.$store.state.exploresurvey.media[key].tags) > 0) {
                            if (found) {
                                this.medianumber = count;
                                return;
                            }
                        }
                        if (key === this.currentmedia.ID) {
                            found = true;
                        }
                        count++;
                    }
                },
                addTag() {
                    this.$store.state.clickmode = "addtag";
                },
                closeAddTag() {
                    this.$store.state.clickmode = "normal";
                },
                focusOn(yaw, pitch) {
                    var trans = this.$store.state.imagetransform;
                    var scaleviewwidth = this.viewwidth * trans.scale;
                    var scaleviewheight = this.viewheight * trans.scale;
                    var newimageviewwidth = this.originalboundingbox.w * trans.scale;
                    var newimageviewheight = this.originalboundingbox.h * trans.scale;
                    var newviewx = (this.viewwidth - scaleviewwidth) / 2;
                    var newviewy = (this.viewheight - scaleviewheight) / 2;
                    var shiftx = newimageviewwidth * (yaw - 0.5);
                    var shifty = newimageviewheight * (pitch - 0.5);
                    var x = newviewx - shiftx;
                    var y = newviewy - shifty;
                    console.log("focusOn ");
                    this.panzoominst.moveTo(x, y);
                },
                prevImageTag() {
                    this.$store.state.currentmediatag = this.$store.state.currentmediatag - 1;
                    var yaw = this.$store.state.mediatags[this.$store.state.currentmediatag - 1].Yaw;
                    var pitch = this.$store.state.mediatags[this.$store.state.currentmediatag - 1].Pitch;
                    if (this.currentmediatype === "pano") {
                        if (this.$store.state.screenmode === "single") {
                            var iframe1 = document.getElementById("iframe1");
                            iframe1.contentWindow.fromC('lookat:' + yaw + ':' + pitch, '*');
                        }
                        else {

                        }
                    }
                    else {
                        this.focusOn(yaw, pitch);
                    }
                },
                nextImageTag() {
                    if (!this.$store.state.currentmediatag) this.$store.state.currentmediatag = 1;
                    else this.$store.state.currentmediatag = this.$store.state.currentmediatag + 1;
                    var yaw = this.$store.state.mediatags[this.$store.state.currentmediatag - 1].Yaw;
                    var pitch = this.$store.state.mediatags[this.$store.state.currentmediatag - 1].Pitch;
                    if (this.currentmediatype === "pano") {
                        if (this.$store.state.screenmode === "single") {
                            var iframe1 = document.getElementById("iframe1");
                            iframe1.contentWindow.fromC('lookat:' + yaw + ':' + pitch, '*');
                        }
                        else {

                        }
                    }
                    else {
                        this.focusOn(yaw, pitch);                     
                    }
                },
                home() {
                    this.$store.state.currentmediatag = null;
                    if (this.currentmediatype === "pano") {
                        if (this.$store.state.screenmode === "single") {
                            var iframe1 = document.getElementById("iframe1");
                            iframe1.contentWindow.fromC('lookat:0:0:90', '*');
                        }
                        else {
                            var iframe1 = document.getElementById("iframe1");
                            iframe1.contentWindow.fromC('lookat:-90:0', '*');
                            var iframe2 = document.getElementById("iframe2");
                            iframe2.contentWindow.fromC('lookat:0:0', '*');
                            var iframe3 = document.getElementById("iframe3");
                            iframe3.contentWindow.fromC('lookat:90:0', '*');
                        }
                    }
                    else {
                        this.yaw = 0;
                        this.pitch = 0;
                        this.fov = 1;
                        this.rememberMediaView(0, 0, 1);
                        this.setZoomPan();
                    }
                },
                /*
                loadPano() {
                    var panourl = this.panoimage.replace("&", "&amp;");
                    var iframe1 = document.getElementById("iframe1");
                    iframe1.contentWindow.fromC('loadpano:' + panourl, '*');
                },
                */
                showMap() {
                    this.$store.state.mapbutton = true;
                    this.$store.state.mapcentre = this.$store.state.mapmarkers[this.medianumber-1];
                    this.$store.state.mapvisible = !this.$store.state.mapvisible;
                },
                checkSize() {
                    var hh = document.children[0].clientHeight;               
                    this.viewheight = hh - 50;
                    this.viewwidth = document.getElementById('explorecard').clientWidth;
                },
                loadMedia() {
                    this.checkSize();
                    this.$store.state.currentmediatag = null;
                    var m = Object.entries(this.$store.state.exploresurvey.media)[this.medianumber - 1];
                    var thisthis = this;
                    this.currentmedia = m[1];
                    this.currentmedia.ID = m[0];
                    this.$store.state.mediaID = m[0];
                    this.startdownload = getsystemmillis();
                    this.loading = true;
                    if (this.currentmedia.Type === "image") {  
                        if (this.$store.state.pagememory[this.medianumber] == null) {
                            this.$store.state.pagememory[this.medianumber] = { yaw: 0, pitch: 0, zoom: 1 };
                        }
                        if (this.currentmedia.DownloadURL === "") {
                            //alert("set listener for download");
                            var dbid = this.$store.state.databaseid;
                            var uid = this.$store.state.user.uid;
                            if (this.$store.state.exploresurvey.Remote) {
                                dbid = this.$store.state.exploresurvey.DatabaseID;
                                uid = this.$store.state.exploresurvey.CreatorID;
                            }
                            var mediaref = 'databases/' + dbid + '/users/' + uid + '/survey-data/' + this.$store.state.exploresurvey.ID + '/media/' + m[0];
                            //alert("mediaref = " + mediaref);
                            firebase.database().ref(mediaref).on('child_changed', snapshot => {
                                var media = snapshot.val();
                                //alert("download " + media.DownloadURL);
                                thisthis.currentmedia.DownloadURL = media;
                                thisthis.imageframesource = thisthis.currentmedia.DownloadURL;
                                thisthis.setZoomPan();
                            }); 
                        }
                        else {
                            this.imageframesource = this.currentmedia.DownloadURL;
                        }
                        this.setZoomPan();
                    }
                    else {
                        if (this.$store.state.pagememory[this.medianumber] == null) {
                            this.$store.state.pagememory[this.medianumber] = { yaw: 0, pitch: 0, zoom: 90 };
                        }
                        this.panoimage = this.currentmedia.DownloadURL;
                    }
                    this.currentmediatype = this.currentmedia.Type;
                },
                setZoomPan() {
                    this.setting = true;
                    var yaw = this.$store.state.pagememory[this.medianumber].yaw;
                    var pitch = this.$store.state.pagememory[this.medianumber].pitch;
                    var zoom = this.$store.state.pagememory[this.medianumber].zoom;
                    console.log("setZoomPan " + this.medianumber + " " + yaw + " " + pitch + " " + zoom);
                    this.panzoominst.zoomAbs(yaw, pitch, zoom);
                    this.panzoominst.moveTo(yaw, pitch);
                    this.setting = false;
                },
                countUniqueMediaTags() {
                    //alert('countUniqueMediaTags')
                    this.$store.state.currentsurveytag = 0;
                    var count = 0;
                    this.surveymediatags = [];
                    this.earliertags = false;
                    this.latertags = false;
                    var zone = 0;
                    var zone0count = 0;
                    var zone2count = 0;
                    for (var key in this.$store.state.exploresurvey.media) {
                        if (key === this.currentmedia.ID) {
                            zone = 1;
                        }
                        else {
                            if (zone == 1)
                                zone = 2;
                        }
                        if (tagcount(this.$store.state.exploresurvey.media[key].tags) > 0) {
                            count++;
                            if (zone == 0)
                                zone0count++;
                            if (zone == 2)
                                zone2count++;
                            this.surveymediatags.push(key);
                            if (key === this.currentmedia.ID) {
                                this.$store.state.currentsurveytag = count;
                            }
                        }
                        if (zone0count > 0) this.earliertags = true;
                        if (zone2count > 0) this.latertags = true;
                    }
                    this.$store.state.surveytagcount = count;
                },
                filterTagsForMedia() {
                    this.mediatagcount = 0;
                    this.$store.state.mediatags = [];
                    var mID = this.currentmedia.ID;
                    //this.$store.state.surveytagcount = Object.entries(this.$store.state.exploresurvey.tags).length;
                    this.countUniqueMediaTags();
                    for (var key in this.$store.state.exploresurvey.tags) {
                        if (this.$store.state.exploresurvey.tags[key].MediaID === mID) {
                            //alert("tagX " + itm[0]);
                            this.$store.state.mediatags.push(this.$store.state.exploresurvey.tags[key]);
                        }
                    }
                    this.mediatagcount = this.$store.state.mediatags.length;
                },
                loadTags() {
                    //now calculate mediatags - need to search through the survey tags looking for media tags that match the current media ID
                    //alert('loadTags');
                    if (this.currentmedia.Type === "pano") {  
                        this.filterTagsForMedia();
                        //alert("loadTags for pano");
                        this.createHotspots();
                    }
                    else {
                        if (!this.$store.state.imageloaded)
                            return;
                        this.filterTagsForMedia();
                        this.createOverlays();
                    }
                },
                mapOverlay(v, r) {
                    var r0 = (1 - r) / 2;
                    var vv = r0 + v * r;
                    //alert('mapOverlay ' + r + ", " + r0 + ", " + v + ", " + vv);
                    return vv;
                },
                myTagsRead(id) {
                    return this.$store.state.mytags[id].Read;
                },
                getTagInfo(itm) {
                    var vmap = this.vmap;
                    var hmap = this.hmap;
                    if (this.currentmedia.Type === "pano") {
                        var yaw = itm.Yaw;
                        var pitch = itm.Pitch;
                    }
                    else {
                        var yaw = this.mapOverlay(itm.Yaw, hmap);
                        var pitch = this.mapOverlay(itm.Pitch, vmap);
                    }
                    var icon = itm.Type + ".png";
                    var id = itm.ID;

                    var mytag = this.$store.state.mytags[id];
                    var unread = "";
                    var tread = mytag.Read;
                    var noteworthy = itm.Total - tread;
                    if ((mytag.Total > 1) && (tread == 0)) {
                        noteworthy = noteworthy - 1;
                    }
                    if ((mytag.Total == 1) && (tread == 0)) {
                        unread = "*";
                    }
                    else {
                        if (noteworthy > 0) {
                            unread = "" + noteworthy;
                        }
                    }
                    var total = "";
                    if (mytag.Total > 1)
                        total += (mytag.Total - 1);
                    var rating = mytag.Rating;
                    if (rating.includes("*")) {
                        unread = "*";
                        rating = rating.replace("*", "");
                    }
                    if (rating.includes("#")) {
                        this.trafficlight = false;
                    }
                    else {
                        this.trafficlight = true;
                    }
                    if (rating.includes("green")) rating = "green";
                    if (rating.includes("amber")) rating = "amber";
                    if (rating.includes("red")) rating = "red";
                    return { icon: icon, rating: rating, total: total, unread: unread, yaw: yaw, pitch: pitch, id: id };
                },
                createHotspots() {
                    //alert('createHotspots');
                    this.$store.state.mediatags.forEach(itm => {
                        var taginfo = this.getTagInfo(itm);
                        var iframe1 = document.getElementById("iframe1");
                        iframe1.contentWindow.fromC('addhotspot:' + taginfo.id + ':' + taginfo.yaw + ':' + taginfo.pitch + ":" + taginfo.icon + ":" + taginfo.rating + ":" + taginfo.unread, '*');
                    });
                },
                createOverlays() {
                    //alert('createOverlays');
                    var overlay = this.$refs.overlay;
                    while (overlay.childElementCount > 1) {
                        overlay.removeChild(overlay.lastChild);
                    }
                    this.$store.state.mediatags.forEach(itm => {
                        var taginfo = this.getTagInfo(itm);
                        var ComponentClass = Vue.extend(Button);
                        var instance = new ComponentClass({ propsData: { source: taginfo.icon, rating: taginfo.rating, total: taginfo.total, unread: taginfo.unread, scale: '6%', yaw: taginfo.yaw, pitch: taginfo.pitch, id:taginfo.id, calling: this }});
                        instance.$slots.default = ['Click me!'];
                        instance.$mount();
                        overlay.appendChild(instance.$el);
                    });
                },
                getHotSpotButton(id) {
                    var overlay = this.$refs.overlay;
                    const children = overlay.childNodes;
                    const len = children.length;
                    for (let i = 0; i < len; i++) {
                        var cid = children[i];
                        if (id === cid.id)
                            return cid.firstChild;
                    }
                    return null;
                },
                redrawNotesBox(xx,yy) {
                    this.addnotetext = false;
                    this.newnote = "";
                    var notetag;
                    var height = 30;
                    var thisthis = this;
                    this.$store.state.mediatags.forEach(itm => {
                        if (itm.ID === this.selectedtagid) {
                            notetag = itm;
                            thisthis.selectedtag = itm;
                            var tm = itm.Time;
                            if (itm.Rating.includes("green"))
                                thisthis.alertlevel = "#00FF00";
                            if (itm.Rating.includes("amber"))
                                thisthis.alertlevel = "#FFA500";
                            if (itm.Rating.includes("red"))
                                thisthis.alertlevel = "#FF0000";
                            thisthis.selectedtag.HowOld = thisthis.getage(tm);
                            thisthis.notes = notetag.Notes;
                            var count = 0;
                            for (var key in notetag.Notes) {
                                tm = notetag.Notes[key].Time;
                                notetag.Notes[key].HowOld = thisthis.getage(tm);
                                notetag.Notes[key].EText = unescape(notetag.Notes[key].Text);
                                count++;
                            };
                            height = height + count * 25;
                        }
                    });

                    if ((height > 30) && (height < 100)) {
                        height = 100;
                    }
                    if (height > 100) {
                        height = 200;
                    }
                    this.hstyle = "position: absolute; left:" + xx + "px; top: " + yy + "px; height:" + height +"px";
                    this.nstyle = "height:" + (height-30) + "px;"
                    this.tagnote = true;
                },
                overlayButtonClicked(id, xx, yy) {
                    this.selectedtagid = id;

                    if (this.currentmediatype === "image") {
                        var el = this.getHotSpotButton(this.selectedtagid);
                        var left = el.offsetLeft;
                        var top = el.offsetTop;

                        var scale = this.imagetransform.scale;
                        var x = this.imagetransform.x;
                        var y = this.imagetransform.y;

                        xx = scale * left + x;
                        yy = scale * top + y;
                    }
                    this.redrawNotesBox(xx, yy);
                    var mtl = this.$store.state.mytags.length;
                    var tag = this.$store.state.mytags[id];
                    if ((tag.Read != tag.Total) || (tag.Rating.includes("*"))) {
                        tag.Read = tag.Total;
                        var dbid = this.$store.state.databaseid;
                        var uid = this.$store.state.user.uid;
                        if (tag.Rating.includes("*")) {
                            tag.Rating = tag.Rating.replace("*", "");
                            firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + "/Rating").set(tag.Rating);
                        }
                        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/tags/' + id + "/Read").set(tag.Read);
                        this.surveyhasbeenmodified();
                    }

                },
                viewChanged(x, y) {
                    //alert("viewChanged " + x + "," + y);
                    this.lab = "" + x + "," + y;
                },
                getWindowWidth(event) {
                    this.windowWidth = document.documentElement.clientWidth;
                    this.checkSize();
                    //this.getoriginalimageboundingbox();
                },
                getWindowHeight(event) {
                    this.windowHeight = document.documentElement.clientHeight;
                    this.checkSize();
                    //this.getoriginalimageboundingbox();
                },
                getage(tm) {
                    var date = new Date();
                    var ticks = ((date.getTime() * 10000) + 621355968000000000);
                    var s = (ticks - tm) / 10000000;
                    var m = Math.floor(s / 60);
                    var h = Math.floor(m / 60);
                    var d = Math.floor(h / 24);
                    if (d > 0) {
                        if (d == 1)
                            return "1 day ago";
                        else
                            return "" + d + " days ago";
                    }
                    if (h > 0) {
                        if (h == 1)
                            return "1 hour ago";
                        else
                            return "" + h + " hours ago";
                    }
                    if (m < 2) 
                        return "1 minute ago";
                    else
                        return "" + m + " minutes ago";
                },
            surveyhasbeenmodified() {
                //alert("surveyhasbeenmodified");
                this.createOverlays();
            }
            },
            computed: {
                gettag() {
                    var id = this.selectedtagid;
                    this.$store.state.mediatags.forEach(itm => {
                        if (itm.ID === id)
                            return itm;
                    });
                    return null;
                },
                surveymodified() {
                    if (this.$store.state.surveymodified > this.currentsurveymodified)
                    {
                        this.currentsurveymodified = this.$store.state.surveymodified;
                        //alert("computed surveymodified");
                        this.updatePage();
                        return true;
                    }
                    return false;
                },
                letterboxpossible() {
                    if (this.windowAspectRatio > 1.3)             //3
                        return true;
                    else
                        return false;
                },
                screenmode() {
                    return this.$store.state.screenmode;
                },
                lab() {
                    return this.$store.state.imagetransform;
                },
                clickmode() {
                    return this.$store.state.clickmode;
                },
                mediacount() {
                    return this.$store.state.mediacount;
                },
                surveytagcount() {
                    return this.$store.state.surveytagcount;
                },
                getimageboundingbox() {
                    var x = this.$store.state.imagetransform.x + (this.$store.state.imagetransform.scale * this.originalboundingbox.x);
                    var y = this.$store.state.imagetransform.y + (this.$store.state.imagetransform.scale * this.originalboundingbox.y);
                    var w = this.$store.state.imagetransform.scale * this.originalboundingbox.w;
                    var h = this.$store.state.imagetransform.scale * this.originalboundingbox.h;
                    return { x: Math.round(x), y: Math.round(y), w: Math.round(w), h: Math.round(h) }
                },
                clockstring() {
                    if (this.mediatime == null)
                        return "unset";
                    return getsurveyage(this.mediatime);
                },
                mediaalertstring() {
                    if (this.mediatagcount == 0) return "0";
                    if (!this.$store.state.currentmediatag) return "" + this.mediatagcount;
                    return "" + this.$store.state.currentmediatag + "/" + this.mediatagcount;
                },
                surveyalertstring() {
                    if (this.$store.state.surveytagcount == 0)
                        return "0";
                    var str = "" + this.$store.state.surveytagcount;
                    var count = 0;
                    var tID = this.currentmedia.ID;
                    var thisthis = this;
                    this.surveymediatags.forEach(itm => {
                        count++;
                        if (itm === tID) {
                            thisthis.$store.state.currentsurveytag = count;
                            str = thisthis.$store.state.currentsurveytag + "/" + thisthis.$store.state.surveytagcount;
                        }
                    });
                    return str;
                },
                mediastring() {
                    return "" + this.medianumber + "/" + this.mediacount;
                },
                firstmedia() {
                    if (this.medianumber == 1)
                        return true;
                    else
                        return false;
                },
                lastmedia() {
                    if (this.medianumber == this.mediacount)
                        return true;
                    else
                        return false;
                },
                firstmediatag() {
                    if (!this.$store.state.currentmediatag) return true;
                    if (this.$store.state.currentmediatag == 1) return true;
                    return false;
                },
                lastmediatag() {
                    if (this.mediatagcount == 0) return true;
                    if (this.$store.state.currentmediatag == this.mediatagcount) return true;
                    return false;
                },
                firstsurveytag() {
                    return !this.earliertags;
                },
                lastsurveytag() {
                    return !this.latertags;
                },
                iframe() {
                    return this.$store.state.iframewindow;
                },
                mapclickcount() {
                    return this.$store.state.mapclickcount;
                }
            },
            watch: {
                mapclickcount() {
                    //alert("mapmarkerclicked " + this.$store.state.mapmarkerclicked);
                    this.medianumber = this.$store.state.mapmarkerclicked + 1;
                },
                surveymodified() {
                    this.surveyhasbeenmodified();      
                },
                medianumber() {
                    this.loadMedia();
                },
                mediacount() {
                    if (this.medianumber == 0) {
                        this.medianumber = 1;
                    }
                    if (this.showlastmedia) {
                        this.medianumber = this.$store.state.mediacount;
                    }
                    //alert("mediacount = " + this.medianumber);
                    this.setMarkers();
                },
                surveytagcount() {
                    this.loadTags();
                },
                iframe() {
                    //alert("foundIframe");
                    window.onmessage = (event) => {
                        var arr = event.data.split(':');
                        //if (arr[0] === "krpanowindow")
                        //this.iframewindow=event.source.window;
                        if (arr[0] === "viewchanged")
                            this.viewChanged(arr[1], arr[2]);
                    };
                }
            },
            beforeDestroy() {
                window.removeEventListener('resize', this.getWindowWidth);
                window.removeEventListener('resize', this.getWindowHeight);
            }
        }
    </script>

    <style>

        .xcontainer {
            margin: 0px;
            padding: 0px;
            background: #FFD375;
        }

        .mediaframe {
            border: hidden;
            margin: 0px;
            width: 100%;
        }

        .mediaframe1 {
            border: hidden;
            margin: 0px;
            width: 33.333%;
        }

        .mediaframe2 {
            border: hidden;
            margin: 0px;
            width: 33.333%;
        }

        .mediaframe3 {
            border: hidden;
            margin: 0px;
            width: 33.333%;
        }

        .labelsmall {
            font-size: 0.8em;
            font-weight: 400;
            text-transform: capitalize;
        }

        .labelbold {
            font-size: 1.2em;
            font-weight: 700;
        }

        .labelclock {
            font-size: 1.0em;
            font-weight: 700;
        }

        .fliphoriz {
            transform: scaleX(-1);
        }

        .drag_overlay {
            z-index: 0;
            border: hidden;
            overflow: hidden;
        }

        .borderless {
            border: hidden;
        }

        .menubold {
            font-size: 1.5em;
            font-weight: bold;
        }

        .menuhead {
            font-size: 1.5em;
            font-weight: normal;
        }

        .mt_auto1 {
            
        }

        .clickable {
            cursor: pointer;
        }

    </style>
